import { client } from "@/http/client"

import { IResponse } from "@/types/api"
import { ICustomerSettings } from "@/types/ISettings"

export const getSettingsByUser = (): Promise<IResponse<ICustomerSettings>> =>
  client.get("/CustomerSettings")

export const updateCustomerSettings = (body:ICustomerSettings):Promise<IResponse<number>>=>
  client.put("/CustomerSettings", body)